module.exports = __webpack_public_path__ + "img/logout-icon.de9b95ee.svg";